module.exports = __webpack_public_path__ + "static/media/hero-cookie-crumbs.1deab6fd.png";